// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export class TraduccionCmpSecondaryTabCmpCookiesAlmacena2 extends TraduccionLiteral {
    /* STATIC */
    protected static override readonly ID: string = "cmp.secondary_tab.cmp_cookies_almacena_2";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpSecondaryTabCmpCookiesAlmacena2 {
        this.VALUES ??= this.completar({
            "valor": {
                "da": "Oplysninger er kun tilgængelige via cookies",
                "de": "Der Zugriff auf Informationen erfolgt nur über Cookies.",
                "en": "Information is only accessed through cookies",
                "fr": "Les informations ne sont accessibles que par le biais de cookies",
                "it": "Si accede ai dati solo attraverso i cookies",
                "nl": "De informatie is alleen toegankelijk via cookies",
                "pt": "A informação só é acedida através de cookies",
                "ru": "Информация доступна только через файлы cookie",
                "pt-BR": "As informações só são acessadas por meio de cookies"
            },
            "defecto": "Acceso a la información utilizando tecnologías distintas a las cookies"
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
